import { getIn } from 'formik';

import {
  type AISuggestionResponse,
  type FieldSuggestion,
  type FieldSchema,
} from 'hb-react/shared/components/AIFormWidget/types';
import { mapAPIResponseToSuggestion } from 'hb-react/shared/components/AIFormWidget/utils';

export const createDefaultFieldSchemas = (
  formData: Record<string, unknown>,
): Array<FieldSchema> =>
  Object.keys(formData).map((field) => ({
    field,
    type: 'text' as const,
    label: field,
  }));

export const extractTargetData = (
  filteredValues: Record<string, unknown>,
  targetFields: Array<FieldSchema>,
): Record<string, unknown> =>
  targetFields.reduce(
    (acc, fieldSchema) => {
      const value = getIn(filteredValues, fieldSchema.field);

      if (value !== undefined) {
        acc[fieldSchema.field] = value;
      }
      return acc;
    },
    {} as Record<string, unknown>,
  );

export const processSuggestions = (
  apiSuggestions: Array<AISuggestionResponse>,
  targetFields: Array<FieldSchema>,
  targetData: Record<string, unknown>,
): Array<FieldSuggestion> =>
  apiSuggestions.map((suggestion) =>
    mapAPIResponseToSuggestion(suggestion, targetFields, targetData),
  );
